import type { Chapter } from '../types.ts';

function pad2(n: number): string {
  return n.toString().padStart(2, '0');
}

export function renderHero(chapter: Chapter): HTMLElement {
  const hero = document.createElement('header');
  hero.className = 'hero';
  hero.dataset['chapter'] = String(chapter.number);

  if (chapter.hero.photo) {
    const img = document.createElement('img');
    img.className = 'hero-photo';
    img.src = chapter.hero.photo;
    img.alt = chapter.hero.alt;
    img.loading = chapter.number === 1 ? 'eager' : 'lazy';
    img.decoding = 'async';
    img.fetchPriority = chapter.number === 1 ? 'high' : 'low';
    hero.appendChild(img);
  } else {
    hero.classList.add('hero--no-photo');
  }

  const overlay = document.createElement('div');
  overlay.className = 'hero-overlay';

  const num = document.createElement('span');
  num.className = 'hero-num';
  num.textContent = pad2(chapter.number);

  const title = document.createElement('h2');
  title.className = 'hero-title';
  title.textContent = chapter.title;

  const cue = document.createElement('span');
  cue.className = 'hero-cue';
  cue.setAttribute('aria-hidden', 'true');
  cue.textContent = 'scroll';

  overlay.append(num, title, cue);
  hero.appendChild(overlay);
  return hero;
}
